import { useMutation } from "@tanstack/react-query";

export const useDepositWithBody = (onError?: (response: Response) => void) => {
  const mutation = useMutation<
    {
      requestId: number;
    },
    Error,
    Record<string, unknown>
  >({
    mutationKey: [onError],
    mutationFn: async (body) => {
      const response = await fetch(
        `${window.__APP_CONFIG.apiBaseUrl}/head/requests`,
        {
          method: "POST",
          // Send the X session cookie: the api's deposit gate reads it to
          // confirm the signed-in user has a registration (rules consent).
          // Without credentials the cookie is dropped cross-origin and a
          // deposit 403s even for a registered user.
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      );

      if (!response.ok) {
        if (onError) {
          onError(response);
        } else {
          // A rejection body carries the reason as {"error": "..."} — e.g. a
          // pre-RequestId screening rejection ("l2_payload failed to decrypt").
          // Surface it to the user; fall back to the status code when the body
          // isn't that shape (proxy errors, HTML error pages, ...).
          const reason = await response
            .json()
            .then((body) => (typeof body?.error === "string" ? body.error : null))
            .catch(() => null);
          throw new Error(
            reason ?? `Hydrozoa operation failed with status ${response.status}`,
          );
        }
      }

      return response.json();
    },
  });

  return mutation;
};
